import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { services, testimonials } from "../data";
import ServiceCard from "../components/ServiceCard";
import SectionHeader from "../components/SectionHeader";

export default function Home() {
  return (
    <main>
      <Helmet>
        <title>VRGlobal Tech | ERP, SEO, Domain, Servers & Ads</title>
        <meta
          name="description"
          content="Professional software services company offering ERP applications, SEO, domain registration, servers, hosting, social media ads and web development."
        />
      </Helmet>

      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-7">
              <div className="hero-badge">
                <i className="bi bi-shield-check me-2"></i>Enterprise-grade
                digital solutions
              </div>
              <h1>
                Build, launch and grow your business with world-class software
                services.
              </h1>
              <p className="hero-text">
                We provide ERP application development, SEO, domain
                registration, servers, hosting, social media ads, websites and
                custom business software with a professional approach.
              </p>
              <div className="d-flex flex-wrap gap-3 mt-4">
                <Link to="/contact" className="btn btn-brand btn-lg">
                  Start Project <i className="bi bi-arrow-right ms-2"></i>
                </Link>
                <Link to="/services" className="btn btn-glass btn-lg">
                  Explore Services
                </Link>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="dashboard-card">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <small className="text-soft">Business Command Center</small>
                    <h4 className="mb-0">Digital Growth Dashboard</h4>
                  </div>
                  <i className="bi bi-bar-chart-line dashboard-main-icon"></i>
                </div>
                {[
                  "ERP Automation",
                  "SEO Visibility",
                  "Server Reliability",
                  "Ad Campaign Growth",
                ].map((item, index) => (
                  <div className="progress-box" key={item}>
                    <div className="d-flex justify-content-between small mb-2">
                      <span>{item}</span>
                      <span>{86 + index * 3}%</span>
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{ width: `${86 + index * 3}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="row g-4">
            {[
              ["360°", "Digital Services"],
              ["100%", "Custom Solutions"],
              ["24/7", "Support Mindset"],
              ["99.9%", "Uptime Focus"],
            ].map(([value, label]) => (
              <div className="col-6 col-lg-3" key={label}>
                <div className="stat-card">
                  <h3>{value}</h3>
                  <p>{label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding" id="services">
        <div className="container">
          <SectionHeader
            eyebrow="Our Services"
            title="Everything your business needs to go digital"
            text="From custom ERP software to SEO, servers and digital marketing, we provide complete technology support under one roof."
          />
          <div className="row g-4 mt-3">
            {services.map((service) => (
              <div className="col-md-6 col-lg-4" key={service.title}>
                <ServiceCard service={service} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-section section-padding">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <SectionHeader
                center={false}
                eyebrow="Why Choose Us"
                title="Secure, scalable and professional business technology"
                text="We focus on clean design, strong security, reliable deployment and long-term business value."
              />
            </div>
            <div className="col-lg-6">
              {[
                "Custom software built around your exact workflow",

                "Domain, SSL, server, hosting and deployment support",
                "Professional support after launch",
              ].map((item) => (
                <div className="feature-line" key={item}>
                  <i className="bi bi-check2-circle"></i>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <SectionHeader
            eyebrow="Client Words"
            title="Built for serious business growth"
          />
          <div className="row g-4 mt-3">
            {testimonials.map((t) => (
              <div className="col-md-4" key={t.name}>
                <div className="testimonial-card">
                  <i className="bi bi-quote"></i>
                  <p>{t.text}</p>
                  <h6>{t.name}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container text-center">
          <h2>Ready to transform your business?</h2>
          <p>
            Let us build your ERP, website, SEO, hosting setup and digital
            marketing system with a premium professional look.
          </p>
          <Link
            to="/contact"
            className="btn btn-light btn-lg rounded-pill px-5 fw-bold"
          >
            Contact Us Today
          </Link>
        </div>
      </section>
    </main>
  );
}
